import script from "./ManageUsersView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageUsersView.vue?vue&type=script&setup=true&lang=ts"

import "./ManageUsersView.vue?vue&type=style&index=0&id=37b64239&lang=scss"

const __exports__ = script;

export default __exports__